import React from 'react';
import { FormError, HelpText } from '@Forms/fields.jsx';
import { validateEmail } from '../validators.js';

const EmailField = ({
  error,
  helpText,
  label,
  name,
  placeholder = '',
  register,
  options = {},
  ...props
}) => {
  // resuable email field
  const combinedOptions = {
    validate: validateEmail,
    ...options,
  };
  return (
    <div
      className={
        `sb-form-item-formgroup sb-form-item-input ` +
        (error ? 'sb-form-item-error' : '')
      }
    >
      <label htmlFor={name}>{label}</label>
      <div className="sb-form-item-content">
        <input
          type="email"
          placeholder={placeholder}
          aria-invalid={error ? 'true' : 'false'}
          {...register(name, combinedOptions)}
          {...props}
        />
        {helpText && <HelpText message={helpText} />}
        {error && <FormError message={error.message} />}
      </div>
    </div>
  );
};

export default EmailField;
